
import Cookies from 'js-cookie'

const key = 'Authorization'
// const storageKey = 'admin_user_info'

export function setUserInfo(storageKey, userinfo) {
  return localStorage.setItem(storageKey, JSON.stringify(userinfo))
}

export function getUserInfo(storageKey) {
  return JSON.parse(localStorage.getItem(storageKey))
}

export function removeUserInfo(storageKey) {
  return localStorage.removeItem(storageKey)
}
export function removeAll() {
  return localStorage.clear();
}

export function setToken(token) {
  return Cookies.set(key, token)
}

export function getToken() {
  return Cookies.get(key)
}

export function removeToken() {
  return Cookies.remove(key)
}
